// 验证码相关

import request from '@/utils/request-login'

/* 发送验证码
@params
data 
{
    "mobile": "**********"
    "sendCodeType":'login' //固定为login
}
@return 
{"code": "200",
    "data": "ideallife",
      "message": "验证码发送成功"
}
*/
export function sendCode(data) {
    data.sendCodeType ='login'
    return request({
        method: 'post',
        url: '/api/common/sendCode',
        params: data
    })
}
/* 验证码登录
@params
data
{
    "username": "**********"
    "code":'******'
}
@return
{
    "code": "200",
    "data": {
        "growLoginPoint": "10",
        "hasWallet": "0",
        "customerImg": "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTK2ialpFmBxHKru4tmt1AHEPon0AbQpu9mhTvicE8cwUfKVd6KRpC844K7fMuCicd8eUpWoCausW85UA/132",
        "tokenKey": "362140F3F8348B424CD788DFE4D76357",
        "username": "13053273111",
        "level": "2",
        "loginPoint": "0",
        "token": "82bcb15d13bbd38ba68918f526a7eb13",
        "userId": 245333,
        "customerNickname": "babycold",
        "openid": "xxxxxxxxxxxxxxxx",
        "hasPassword": true,
        "mobile": "1305327111"
    },
    "message": "登录成功"
}
*/
export function login(data) {
    if (data.passwordChecking){
        return request({
            method: 'post',
            url: '/api/login',
            params: {username:data.username,password:data.password}
        })
    }else if (data.code){
        return request({
            method: 'post',
            url: '/api/codeLogin',
            params: { username: data.username, code: data.code }
        })
    }else{
        return nil
    }

}

export function loginByPassword(data) {
    return request({
        method: 'post',
        url: '/api/login',
        params: { username: data.username, code: data.code }
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js